import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import _ from 'lodash';

import Store from 'core/store/store';
import { setCalendars } from 'core/store/admin/action';
import { getCalendars } from 'core/store/admin/selectors';

import Calendar from 'core/apis/Calendar';

import Modal from 'components/Modal/Modal';
import Card from 'components/Card/Card';
import CalendarForm from 'containers/Admin/AdminPanel/ModelForm/CalendarForm';
import ConfirmForm from 'containers/Admin/AdminPanel/ModelForm/ConfirmForm';

import CrudTable from 'containers/Admin/AdminPanel/CrudTable/CrudTable';

interface CalendarType {
    id: number;
    title: string;
    color: string;
    time_interval: number;
    available_slots: number;
    limit: number | null;
    price: number | null;
    created_at: string;
    updated_at: string;
}

const _hiddenAttributes = [
    'updated_at'
];

const CalendarIndex = () => {

    const calendars = useSelector(getCalendars);

    const [initialized, setInitialized] = useState<boolean>(false);

    const [showModal, setShowModal] = useState<string>('');
    const [target, setTarget] = useState<CalendarType | null>();

    useEffect(() => {
        const setup = () => {
            const adminState = Store.getState().admin;

            if (_.isEmpty(adminState.calendars)) {
                dispatchCalendars();
            }
            setInitialized(true);
        }

        if (!initialized) {
            setup();
        }
    }, [calendars, initialized]);

    const dispatchCalendars = async () => {
        const request = await Calendar.index();
        Store.dispatch(setCalendars({ calendars: request.data }));
    }

    const onCreate = async () => {
        setShowModal('CalendarForm');
    }

    const onEdit = (target: CalendarType) => {
        setTarget(target);
        setShowModal('CalendarForm');
    }

    const onDelete = (target: CalendarType) => {
        setTarget(target);
        setShowModal('ConfirmForm');
    }

    const handleClose = () => {
        setShowModal('');
        setTarget(null);
    }

    return (
        <div>
            <Card>
                <CrudTable key={'calendars'} model={_.map(calendars, calendar => _.omit(calendar, _hiddenAttributes))} onEditAction={onEdit} onDeleteAction={onDelete} onCreateAction={onCreate} />
            </Card>

            <Modal show={showModal === 'CalendarForm'} handleClose={handleClose}>
                <CalendarForm key={Math.random()} target={target} handleClose={() => { dispatchCalendars(); handleClose() }} />
            </Modal>

            <Modal show={showModal === 'ConfirmForm'} handleClose={handleClose}>
                <ConfirmForm target={target} title='Verwijder agenda' message='Weet u zeker dat u deze agenda wilt verwijderen?' action='DELETE' handleConfirm={async () => { await Calendar.delete(target!.id); dispatchCalendars(); }} handleClose={handleClose} />
            </Modal>
        </div>
    );
}

export default CalendarIndex;